const smartbi = {
  state: {
    hasBank: '', // 是否有银行渠道分析
    hasMainRisk: '', // 是否有主副维度
    hasProject: '', // 是否有产品分析
    hasRiskHuman: '', // 是否有险类维度
    hasRiskHelth: '', // 是否有健康险
    hasStru: '', // 是否有结构分析
    hasChannel: '', // 是否有渠道分析
    hasStruWorkyear: '', // 司龄
    hasRegular: '', // 转正维度
    indexDay: '', // 是否有日
    indexMonth: '', // 是否有月
    indexYear: '', // 是否有年
    unit: '', // 单位
    cal: '', // 口径:考核口径1，标准口径0。
    realTime: '', // 是否实时：实时：1，离线：0
    hasAchievementRate: '', // 是否有达成率
    isBatchFinish: '', // 实时数据是否查询完成
    headUnit: '', // 模块首页趋势图表格表头列名称
    isPreEntry: '', // 预录入指标标识  1代表是
    startTime: '' // 预录入指标开始时间
  },
  mutations: {
    // 是否有银行渠道分析
    SMARTBI_HAS_BANK: (state, type) => {
      state.hasBank = type
    },
    // 是否有主副维度
    SMARTBI_HAS_MAIN_RISK: (state, type) => {
      state.hasMainRisk = type
    },
    // 是否有产品分析
    SMARTBI_HAS_PROJECT: (state, type) => {
      state.hasProject = type
    },
    // 转正维度
    SMARTBI_HAS_REGULAR: (state, type) => {
      state.hasRegular = type
    },
    // 是否有渠道分析
    SMARTBI_HAS_CHANNEL: (state, type) => {
      state.hasChannel = type
    },
    // 是否有结构分析
    SMARTBI_HAS_STRU: (state, type) => {
      state.hasStru = type
    },
    // 司龄
    SMARTBI_HAS_STRU_WORKYREAR: (state, type) => {
      state.hasStruWorkyear = type
    },
    // 是否有日
    SMARTBI_INDEX_DAY: (state, type) => {
      state.indexDay = type
    },
    // 是否有月
    SMARTBI_INDEX_MONTH: (state, type) => {
      state.indexMonth = type
    },
    // 是否有年
    SMARTBI_INDEX_YEAR: (state, type) => {
      state.indexYear = type
    },
    // 单位
    SMARTBI_UNIT: (state, type) => {
      state.unit = type
    },
    SMARTBI_HAS_RISK_HUMAN: (state, type) => {
      state.hasRiskHuman = type
    },
    SMARTBI_HAS_RISK_HELTH: (state, type) => {
      state.hasRiskHelth = type
    },
    SMARTBI_CAL: (state, type) => {
      state.cal = type
    },
    SMARTBI_REAL_TIME: (state, type) => {
      state.realTime = type
    },
    SMARTBI_HAS_ACHIEVEMENT_RATE: (state, type) => {
      state.hasAchievementRate = type
    },
    SMARTBI_IS_BATCH_FINISH: (state, type) => {
      state.isBatchFinish = type
    },
    // 头部名称
    SMARTBI_HEADUNIT: (state, type) => {
      state.headUnit = type
    },
    SMARTBI_IS_PRE_ENTRY: (state, type) => {
      state.isPreEntry = type
    },
    SMARTBI_START_TIME: (state, type) => {
      state.startTime = type
    }
  },
  actions: {
  }
}
export default smartbi



// WEBPACK FOOTER //
// ./src/store/modules/smartbi.js